import { getWindowConfig, } from '~/utils/env';
import { Account, } from './account';
import { validateCustomContent, } from './store/custom-content';

const customContentCandidate = getWindowConfig('CustomContent');

validateCustomContent(customContentCandidate);

Account('#app', (s) => getWindowConfig(s), customContentCandidate);
